import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { ApiError } from './api/client'
import { router } from './routes'
import { ToastProvider } from './ui'
import './styles/base.css'
import './ui/ui.css'

// Retrying an authentication or authorization failure just burns rate-limit budget; only
// transient infrastructure failures are worth a second attempt.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) =>
        error instanceof ApiError ? error.isTransient && failureCount < 2 : failureCount < 1,
      refetchOnWindowFocus: false,
      // Lists are re-read on navigation rather than served from a stale cache; a participant
      // imported a minute ago must appear when the admin comes back to the screen.
      staleTime: 15_000,
    },
    mutations: {
      retry: false,
    },
  },
})

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  )
}
